module.exports = __webpack_public_path__ + "img/30000.f1e8658c.jpg";